import {
  CANCEL_REGISTRATION,
  CLEAR_EASY_JOIN_ERROR,
  CLEAR_GOOGLE_ERROR,
  CLEAR_RESELLER_TOKEN_ERROR,
  FETCH_REGISTRATION_TOKEN_START,
  FETCH_REGISTRATION_TOKEN_FULFILLED,
  FETCH_REGISTRATION_TOKEN_REJECTED,
  FETCH_RESELLER_TOKEN_START,
  FETCH_RESELLER_TOKEN_FULFILLED,
  FETCH_RESELLER_TOKEN_REJECTED,
  REGISTER_USER_START,
  REGISTER_USER_FULFILLED,
  REGISTER_USER_REJECTED,
  RESET_EASY_JOIN,
  SET_GOOGLE_USER,
  SET_REGISTERING_WITH_GOOGLE,
  SUBMIT_EASY_JOIN_CODE_START,
  SUBMIT_EASY_JOIN_CODE_FULFILLED,
  SUBMIT_EASY_JOIN_CODE_REJECTED,
} from './actionTypes';

const initialState = {
  easyJoinData: {},
  easyJoinError: '',
  googleUser: {},
  isEasyJoinCompleted: false,
  isRegisteringWithGoogle: false,
  registerUserError: null,
  resellerTokenError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CANCEL_REGISTRATION: {
      return {
        ...state,
        easyJoinData: {},
        easyJoinError: '',
        googleUser: {},
        isEasyJoinCompleted: false,
        isRegisteringWithGoogle: false,
        registerUserError: null,
        resellerTokenError: null,
      };
    }
    case CLEAR_EASY_JOIN_ERROR: {
      return {
        ...state,
        easyJoinError: '',
      };
    }
    case CLEAR_GOOGLE_ERROR: {
      return {
        ...state,
      };
    }
    case CLEAR_RESELLER_TOKEN_ERROR: {
      return {
        ...state,
        resellerTokenError: null,
      };
    }
    case FETCH_REGISTRATION_TOKEN_START: {
      return {
        ...state,
        registrationTokenError: null,
      };
    }
    case FETCH_REGISTRATION_TOKEN_FULFILLED: {
      return {
        ...state,
        registrationToken: action.payload,
      };
    }
    case FETCH_REGISTRATION_TOKEN_REJECTED: {
      return {
        ...state,
        registrationTokenError: action.payload,
      };
    }
    case FETCH_RESELLER_TOKEN_START: {
      return {
        ...state,
        resellerTokenError: null,
      };
    }
    case FETCH_RESELLER_TOKEN_FULFILLED: {
      return {
        ...state,
        registrationToken: action.payload,
      };
    }
    case FETCH_RESELLER_TOKEN_REJECTED: {
      return {
        ...state,
        resellerTokenError: action.payload,
      };
    }
    case REGISTER_USER_START: {
      return {
        ...state,
        registerUserError: null,
      };
    }
    case REGISTER_USER_FULFILLED: {
      return {
        ...state,
        googleUser: {},
        registerUserError: null,
      };
    }
    case REGISTER_USER_REJECTED: {
      return {
        ...state,
        registerUserError: action.payload,
      };
    }
    case RESET_EASY_JOIN: {
      return {
        ...state,
        easyJoinData: {},
        isEasyJoinCompleted: false,
      };
    }
    case SET_GOOGLE_USER: {
      return {
        ...state,
        googleUser: action.payload,
      };
    }
    case SET_REGISTERING_WITH_GOOGLE: {
      return {
        ...state,
        isRegisteringWithGoogle: action.payload,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_START: {
      return {
        ...state,
        easyJoinError: '',
      };
    }
    case SUBMIT_EASY_JOIN_CODE_FULFILLED: {
      return {
        ...state,
        easyJoinData: action.payload,
        isEasyJoinCompleted: true,
      };
    }
    case SUBMIT_EASY_JOIN_CODE_REJECTED: {
      return {
        ...state,
        easyJoinError: action.payload,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
